
import External from './components/External';

export default {
  i18nComponentKey: 'WidgetReviewsExternal.WidgetReviewsExternalPc',
  name: 'WidgetReviewsExternalPc',
  components: { External }
};
